// extracted by mini-css-extract-plugin
export default {"separator":"Separator_separator__VyxE4","noBorder":"Separator_noBorder__lkfwQ","noMargin":"Separator_noMargin__Pa9+D"};